import { Paragraph, TextRun } from 'docx'
import { ProcessingContext } from '../types'
import { processInlineFormatting } from './inlineFormatting'

/**
 * Process list lines and return paragraph or null
 */
export function processList(
  trimmedLine: string,
  context: ProcessingContext
): Paragraph | null {
  // Handle ordered lists
  if (trimmedLine.match(/^\d+\.\s+/)) {
    const listText = trimmedLine.replace(/^\d+\.\s+/, '')
    const processedRuns = processInlineFormatting(listText, context.font, context.fontSize)
    return new Paragraph({
      children: [
        new TextRun({ text: '1. ', size: context.fontSize, font: context.font, color: '000000' }),
        ...processedRuns
      ],
      spacing: { after: 60 }
    })
  }

  // Handle unordered lists (-, *, +)
  if (trimmedLine.match(/^[-*+]\s+/)) {
    const listText = trimmedLine.replace(/^[-*+]\s+/, '')
    
    // Handle task lists [x] and [ ]
    if (listText.startsWith('[x]') || listText.startsWith('[ ]')) {
      const isChecked = listText.startsWith('[x]')
      const taskText = listText.replace(/^\[[ x]\]\s*/, '')
      const processedRuns = processInlineFormatting(taskText, context.font, context.fontSize)
      
      return new Paragraph({
        children: [
          new TextRun({ text: isChecked ? '☑ ' : '☐ ', size: context.fontSize, font: context.font, color: '000000' }),
          ...processedRuns
        ],
        spacing: { after: 60 }
      })
    } else {
      const processedRuns = processInlineFormatting(listText, context.font, context.fontSize)
      return new Paragraph({
        children: [
          new TextRun({ text: '• ', size: context.fontSize, font: context.font, color: '000000' }),
          ...processedRuns
        ],
        spacing: { after: 60 }
      })
    }
  }

  return null
}